import React from 'react';
import { VIDEOS, VIDEO_ORDER, TAKE_LINES, IDS_URL, whyText, wantText } from '../config/builtQuiz';

const TEAM = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/e40b6cc1099947be_team-photo.jpg';

const Video = ({ id, withTitle }) => {
  const v = VIDEOS[id];
  return (
    <figure className="qz-video" data-testid={`quiz-video-${id}`}>
      {withTitle && <figcaption className="qz-video-title">{v.title}</figcaption>}
      <div className="qz-video-frame">
        <iframe
          src={`${v.src}?rel=0&playsinline=1&modestbranding=1`}
          title={v.title}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
        />
      </div>
      <p className="qz-caption">
        {v.caption}
        {v.ids && <> <a href={IDS_URL} target="_blank" rel="noopener noreferrer" className="op-link">income disclosure</a></>}
      </p>
    </figure>
  );
};

const Videos = ({ know }) => (know === 'all' ? (
  <div className="qz-videos" data-testid="quiz-videos-all">
    {VIDEO_ORDER.map((id) => <Video key={id} id={id} withTitle />)}
    <p className="op-p">
      <a href="/run-it" target="_blank" rel="noopener noreferrer" className="op-link" data-testid="quiz-full-breakdown-link">want the whole thing? watch the full 26-minute breakdown →</a>
    </p>
  </div>
) : <Video id={know} />);

const ProductsFirst = ({ know }) => (
  <>
    <p className="op-p">here&apos;s me on {know === 'all' ? 'all of it' : VIDEOS[know].phrase}.</p>
    <Videos know={know} />
  </>
);

const CloserLook = ({ know }) => (
  <>
    <p className="op-p">
      {know === 'all'
        ? "before you decide anything, i'd want you to see all of it, so here's me explaining each piece, about a minute each."
        : `before you decide anything, i'd want you to see ${VIDEOS[know].phrase}, so here's me explaining it.`}
    </p>
    <Videos know={know} />
    <p className="op-p">and you don&apos;t have to give up your work for this, it gets to be both. you don&apos;t need to build more, you need to get paid more for what you&apos;ve already built, so i&apos;ll hand you everything i use.</p>
    <img src={TEAM} alt="kristen hinman with women on her team" className="qz-team" data-testid="quiz-team-photo" />
  </>
);

export const QuizResult = ({ take, answers, want }) => (
  <div className="qz-result" data-testid="quiz-result" data-take={take}>
    <p className="qz-label">based on your answers</p>
    <h3 className="qz-result-h">okay, here&apos;s <span className="qz-hl">my take</span></h3>
    <p className="op-p qz-take" data-testid="quiz-take-line">{TAKE_LINES[take]}</p>
    <p className="op-p" data-testid="quiz-why">{whyText(take, answers)}</p>
    {take === 'products_first' && <ProductsFirst know={answers.know} />}
    {(take === 'closer_look' || take === 'full_model') && <CloserLook know={answers.know} />}
    <div className="qz-want" data-testid="quiz-want">{wantText(take, want)}</div>
    <p className="qz-live" data-testid="quiz-see-you-live">see you live.</p>
    <p className="qz-fine">
      this is my take based on the answers you picked. i&apos;m an independent monat market partner. income isn&apos;t guaranteed. see the{' '}
      <a href={IDS_URL} target="_blank" rel="noopener noreferrer" className="op-link">income disclosure statement</a>. product results vary.
    </p>
  </div>
);
